import React, { useState, useEffect } from 'react';
import './HeroSlider.css';
import { useNavigate } from 'react-router-dom';

const slides = [
    {
        image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?auto=format&fit=crop&q=80&w=2000',
        title: 'Escape to the Maldives',
        subtitle: 'Experience ultimate luxury in the heart of the Indian Ocean.',
    },
    {
        image: 'https://images.unsplash.com/photo-1464822759023-fed622ff2c3b?auto=format&fit=crop&q=80&w=2000',
        title: 'Majestic Swiss Alps',
        subtitle: 'Discover the beauty of snow-capped peaks and serene lakes.',
    },
    {
        image: 'https://images.unsplash.com/photo-1493976040374-85c8e12f0c0e?auto=format&fit=crop&q=80&w=2000',
        title: 'Mystical Kyoto Nights',
        subtitle: 'Wander through ancient temples and cherry blossom gardens.',
    },
];

const HeroSlider = () => {
    const [current, setCurrent] = useState(0);
    const navigate = useNavigate();

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrent((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
        }, 5000);
        return () => clearInterval(timer);
    }, []);

    const nextSlide = () => {
        setCurrent(current === slides.length - 1 ? 0 : current + 1);
    };

    const prevSlide = () => {
        setCurrent(current === 0 ? slides.length - 1 : current - 1);
    };

    return (
        <div className="hero-slider">
            {slides.map((slide, index) => (
                <div
                    key={index}
                    className={`slide ${index === current ? 'active' : ''}`}
                    style={{ backgroundImage: `url(${slide.image})` }}
                >
                    <div className="slide-overlay"></div>
                    <div className="slide-content">
                        <h1 className="slide-title">{slide.title}</h1>
                        <p className="slide-subtitle">{slide.subtitle}</p>
                        <div className="slide-actions">
                            <button className="btn-primary" onClick={()=> navigate('/packages')}>Explore Package</button>
                            <button className="btn-secondary " onClick={()=> navigate('/contact')}>
                                <i className="fas fa-phone"></i> Call Now
                            </button>
                        </div>
                    </div>
                </div>
            ))}

            <button className="nav-btn prev" onClick={prevSlide}>
                &#10094;
            </button>
            <button className="nav-btn next" onClick={nextSlide}>
                &#10095;
            </button>

            <div className="dots">
                {slides.map((_, index) => (
                    <span
                        key={index}
                        className={`dot ${index === current ? 'active' : ''}`}
                        onClick={() => setCurrent(index)}
                    ></span>
                ))}
            </div>
        </div>
    );
};

export default HeroSlider;
